// extracted by mini-css-extract-plugin
export default {"title":"ModalHeader_title__Umwf2","action":"ModalHeader_action__NWZAo"};